/* eslint-disable no-unneeded-ternary */
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Center from '../../assets/styles/Center';
import DefaultContainer from '../../assets/styles/DefaultContainer';
import Text from '../../assets/styles/Text';
import * as styles from './styles';

export default function Error({ isError, message }) {
  if (!isError) return null;

  return (
    <DefaultContainer>
      <Center className="center">
        <styles.Container>
          <Text.H2 $bold>Erro ao carregar informações</Text.H2>
          <Text.P>
            {message
              ? message
              : 'Erro no servidor, por favor volte mais tarde ou contate o suporte!'}
          </Text.P>

          <Link to="/">
            <Text.Span $bold>Voltar para a Home</Text.Span>
          </Link>
        </styles.Container>
      </Center>
    </DefaultContainer>
  );
}

Error.propTypes = {
  isError: PropTypes.bool.isRequired,
  message: PropTypes.string,
};
